//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetLineNumber",{R_:{lineNumber:''}},0,0],[[],"GetInputPartName",{R_:{partName:''}},0,0],[[],"GetInvalidToken",{R_:{token:''}},0,0]],[]];
SPLM.AssyCloneLogFileFailures = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AssyCloneLogFileFailures";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;